<div class="logo-container">
	<img class="img" src="/assets/img/dropbox-sign-plus-procore.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- SCREEN 1 -->
<ng-container *ngIf="!loading">
	<div class="text-container">Welcome! To begin, verify the details that will be used for administrative and billing purposes:</div>
	<form #f="ngForm" [formGroup]="form">
		<div class="form-container">
			<div class="form-text-container">Company name:</div>
			<input #inputCompanyName formControlName="companyName" [ngClass]="{'valid': companyNameValid == true, 'invalid': companyNameValid == false}" (keyup)="doCompanyNameValidation($event)" (change)="doCompanyNameValidation($event)" />

			<div class="form-text-container">Administrator name:</div>
			<input #inputName formControlName="name" [ngClass]="{'valid': nameValid == true, 'invalid': nameValid == false}" (keyup)="doNameValidation($event)" (change)="doNameValidation($event)" />

			<div class="form-text-container">Administrator e-mail address:</div>
			<input #inputEmail formControlName="email" [ngClass]="{'valid': emailValid == true, 'invalid': emailValid == false}" (keyup)="doEmailValidation($event)" (change)="doEmailValidation($event)" />

			<div class="form-text-container">Billing e-mail address:</div>
			<input #inputBillingEmail formControlName="billingEmail" [ngClass]="{'valid': billingEmailValid == true, 'invalid': billingEmailValid == false}" (keyup)="doBillingEmailValidation($event)" (change)="doBillingEmailValidation($event)" />
		</div>
	</form>

	<div class="button-container" *ngIf="!loading">
		<button class="disabled" *ngIf="!companyNameValid || !emailValid || !billingEmailValid || !nameValid">Continue</button>
		<button *ngIf="companyNameValid && emailValid && billingEmailValid && nameValid" (click)="computeCustomerId()">Continue</button>
	</div>
</ng-container>